import { isEmpty } from "lodash";
import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";
import AuthContext from "../context/AuthContext";

const Promo = () => {
  let {
    launchEGTCasino,
    user,
    launchCasino,
    dolaunchCasinoNew,
    dolaunchCasinoRyoal,setLoginModal
  } = useContext(AuthContext);
  const navigate = useNavigate();
  const handelChange = (res, game, type) => {
    if (!isEmpty(user)) {
      dolaunchCasinoNew(
        game == "poker"
          ? {
              gameCode: res?.gameCode,
              legacy: res?.legacy,
              type: type,
            }
          : {
              gameCode: res?.gameCode,
              legacy: res?.legacy,
              type: type,
            }
      );
    } else {
      setLoginModal(true)
    }
  };

  const handel = (res) => {
    if (!isEmpty(user)) {
      if (!isEmpty(res?.gameid)) {
        launchEGTCasino({
          platForm: res?.platForm,
          gameType: res?.gameType,
          casinoType: res?.casinoType,
          gameid: res?.gameid,
        });
      } else {
        launchCasino({
          platForm: res?.platForm,
          gameType: res?.gameType,
          casinoType: res?.casinoType,
          isLobbyTrue: res?.isLobbyTrue,
        });
      }
    } else {
      setLoginModal(true)
    }
  };
  return (
    <section className="mod-quick-links">
      <h1 className="header">Play Games</h1>
      <div className="widget-content">
        {Array?.map((res) => {
          return (
            <div className="game-item">
              <div className="game-item-wrapper">
                <img
                  className="game-item-image"
                  src={res?.image || res?.url_thumb}
                />
                <div className="game-item-overlay">
                  <div className="game-item-overlay-cta-wrapper">
                    <a
                      onClick={() => {
                        if (!isEmpty(user)) {
                          if (res?.newType == "Evo") {
                            navigate("/casino/Evolution");
                          } else if (
                            res?.legacy == "aura" ||
                            res?.legacy == "67722-1_8"
                          ) {
                            handelChange(res, "poker", "first");
                          } else if (!isEmpty(res?.url_thumb)) {
                            dolaunchCasinoRyoal(res);
                          } else {
                            handel(res);
                          }
                        } else {
                          setLoginModal(true)
                        }
                      }}
                      href="#"
                      className="game-item-default-cta game-item-primary-cta"
                    >
                      Play Now
                    </a>
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
};

const Array = [
  {
    image: require("../img/home/evolutiongaming.webp"),
    newType: "Evo",

    title: "EVOLUTION",
    type: "evo",
    key: "live",
    platForm: "EVOLUTION",
    gameType: "",
    casinoType: "EVOLUTION-LIVE-001",
    isLobbyTrue: true,
  },
  {
    game_id: "100000",
    game_name: "Ezugi Lobby",
    category: "LOBBY",
    provider_name: "EZUGI",
    sub_provider_name: "Ezugi",
    status: "ACTIVE",
    url_thumb: require("../img/home/ezugi.webp"),
    game_code: "ezg_lobby",
  },
  {
    game_id: "203552",
    game_name: "BOMBAY LIVE",
    category: "Live Games",
    provider_name: "DC",
    sub_provider_name: " Bombay Live",
    status: "ACTIVE",
    url_thumb: require("../img/home/bombaylive.webp"),
    game_code: "bbl_bombaylivelobby",
  },
  {
    image: require("../img/home/aesexy.webp"),
    title: "SEXYBCRT",
    type: "sexy",
    key: "live",
    platForm: "SEXYBCRT",
    gameType: "LIVE",
    casinoType: "",
    isLobbyTrue: true,
  },
  {
    image: require("../img/home/pragmatic.webp"),
    title: "PP",
    type: "pp",
    key: "live",
    platForm: "PP",
    gameType: "LIVE",
    casinoType: "",
  },
  {
    image: require("../img/home/jdbgaming.webp"),
    title: "JDB",
    type: "jdb",
    key: "slot",
    gameType: "SLOT",
    platForm: "JDB",
  },
  {
    image: require("../img/home/fachaigaming.webp"),
    title: "FC",
    type: "fc",
    key: "slot",
    gameType: "SLOT",
    platForm: "FC",
  },
  {
    image: require("../img/home/avaitrix.jpg"),
    gameCode: "9999",
    legacy: "67722-1_8",
    title: "AviatorX",
  },
  // {
  //   game_id: "280000",
  //   game_name: "Vivo Lobby",
  //   category: "LOBBY",
  //   provider_name: "DC",
  //   sub_provider_name: "Vivo Games",
  //   status: "ACTIVE",
  //   url_thumb: VivoImage,
  //   game_code: "vivo_lobby",
  // },
  {
    image: require("../img/home/spade.webp"),
    title: "SG",
    type: "spade",
    key: "slot",
    gameType: "SLOT",
    platForm: "SPADE",
  },
  {
    image: require("../img/home/betgames.webp"),
    title: "BG",
    type: "bg",
    key: "live",
    platForm: "BG",
    gameType: "LIVE",
    casinoType: "",
  },
  {
    game_id: "900000",
    game_name: "Royal Gaming Live Lobby",
    category: "LOBBY",
    provider_name: "RG",
    sub_provider_name: "Royal Gaming Lobby",
    status: "ACTIVE",
    url_thumb: "https://cdn.dreamcasino.live/rg_live_lobby.webp",
    game_code: "RG-LIVELOBBY",
  },

  {
    image: require("../img/home/auraLobby.webp"),
    title: "Lobby",
    gameCode: "98789",
    legacy: "aura",
  },
  {
    image: require("../img/home/g3.jpg"),
    title: "Lobby",
    gameCode: "98789",
    legacy: "aura",
  },
  {
    image: require("../img/home/g4.jpg"),
    title: "Lobby",
    gameCode: "98789",
    legacy: "aura",
  },
  {
    image: require("../img/home/g6.jpg"),
    title: "Lobby",
    gameCode: "98789",
    legacy: "aura",
  },
  {
    image: require("../img/home/g7.jpg"),
    title: "Lobby",
    gameCode: "98789",
    legacy: "aura",
  },
  {
    image: require("../img/home/g8.jpg"),
    title: "Lobby",
    gameCode: "98789",
    legacy: "aura",
  },
  {
    image: require("../img/home/g9.jpg"),
    title: "Lobby",
    gameCode: "98789",
    legacy: "aura",
  },
  {
    image: require("../img/home/g10.jpg"),
    title: "Lobby",
    gameCode: "98789",
    legacy: "aura",
  },
  {
    image: require("../img/home/g11.jpg"),
    title: "Lobby",
    gameCode: "98789",
    legacy: "aura",
  },
];
export default Promo;
